@if (extension) {
<div class="extension-container">
    <div class="content">
        @if (extension !== undefined) {
        <form [formGroup]="extensionForm" (ngSubmit)="onSubmit()">
            <div class="form-content">
                <mat-card appearance="outlined" class="box default-card">
                    <mat-card-content>
                        <div class="card-content">
                            <mat-card style="width: 100%" appearance="outlined">
                                <mat-card-header>
                                    <mat-card-title class="card-title">{{ 'Extension.IdentityTitle' | translate }}</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="input-content">
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.NamePlaceholder' | translate }}</mat-label>
                                                <input matInput formControlName="name" autocomplete="off" [readonly]="extensionForm.get('type').value === 'device'" />
                                            </mat-form-field>
                                        </div>
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.NumberPlaceholder' | translate }}</mat-label>
                                                <input matInput formControlName="number" autocomplete="off" [readonly]="!isCreation" />
                                                @if (extensionForm.get('number').errors?.pattern) {
                                                <mat-error>
                                                    {{ 'Extension.NumberPatternError' | translate }}
                                                </mat-error>
                                                }
                                            </mat-form-field>
                                        </div>
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.SitePlaceholder' | translate }}</mat-label>
                                                <mat-select formControlName="siteId">
                                                    @for (site of sites; track site) {
                                                    <mat-option [value]="site.id">
                                                        {{ site.name }}
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            @if (!isCreation) {
                            <mat-card style="width: 100%" appearance="outlined">
                                <mat-card-header>
                                    <mat-card-title class="card-title">{{ 'Extension.StateAndStatusTitle' | translate }}</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="input-content">
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.RegistrationStatePlaceholder' | translate }}</mat-label>
                                                @if (extension.registrationState === registrationStates.registered) {
                                                <mat-icon matSuffix class="color-registered">check_circle</mat-icon>
                                                } @if (extension.registrationState === registrationStates.unregistered) {
                                                <mat-icon matSuffix class="color-unregistered">cancel</mat-icon>
                                                } @if (extension.registrationState === registrationStates.undefined) {
                                                <mat-icon matSuffix class="color-undefined">remove_circle</mat-icon>
                                                }
                                                <input matInput value="{{ 'EnumRegistrationStates.' + extension.registrationState | translate }}" readonly />
                                            </mat-form-field>
                                        </div>
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.ActiveStatePlaceholder' | translate }}</mat-label>
                                                <input matInput value="{{ 'EnumActiveStates.' + extension.activeState | translate }}" readonly />
                                            </mat-form-field>
                                        </div>
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.CreatedAtPlaceholder' | translate }}</mat-label>
                                                <input matInput value="{{ extension.createdAt | translateDate : 'short' }}" readonly />
                                            </mat-form-field>
                                        </div>
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.UpdatedAtPlaceholder' | translate }}</mat-label>
                                                <input matInput value="{{ extension.updatedAt | translateDate : 'short' }}" readonly />
                                            </mat-form-field>
                                        </div>
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.RegistrationDatetimePlaceholder' | translate }}</mat-label>
                                                <input matInput value="{{ extension.registrationDatetime | translateDate : 'short' }}" readonly />
                                            </mat-form-field>
                                        </div>
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.ActiveDatetimePlaceholder' | translate }}</mat-label>
                                                <input matInput value="{{ extension.activeDatetime | translateDate : 'short' }}" readonly />
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                            }

                            <mat-card style="width: 100%" appearance="outlined">
                                <mat-card-header>
                                    <mat-card-title class="card-title">{{ 'Extension.ConfigurationTitle' | translate }}Configuration</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="input-content">
                                        @if (!isCreation) {
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.AllowedNetworkPlaceholder' | translate }}</mat-label>
                                                <input matInput formControlName="allowedNetwork" autocomplete="off" readonly />
                                            </mat-form-field>
                                        </div>
                                        }
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.TypePlaceholder' | translate }}</mat-label>
                                                <mat-select formControlName="type">
                                                    @for (type of extensionTypes; track type) { @if ((type !== 'device' && isCreation) || !isCreation) {
                                                    <mat-option [value]="type">
                                                        {{ 'EnumExtensionTypes.' + type | translate }}
                                                    </mat-option>
                                                    } }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        @if (extensionForm.get('type').value === 'user') {
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.UserPlaceholder' | translate }}</mat-label>
                                                <input type="text" matInput [matAutocomplete]="auto" formControlName="userId" />
                                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUser" (optionSelected)="userSelectionChange($event)">
                                                    @for (user of filteredUsers | async; track user) {
                                                    <mat-option [value]="user.id">
                                                        {{ user.account }}
                                                    </mat-option>
                                                    }
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                        } @if (extensionForm.get('type').value === 'service') {
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.ServicePlaceholder' | translate }}</mat-label>
                                                <mat-select formControlName="service">
                                                    @for (service of services; track service) {
                                                    <mat-option [value]="service.name">
                                                        {{ service.name }}
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        } @if (extensionForm.get('type').value === 'group') {
                                        <div>
                                            <mat-form-field style="width: 250px">
                                                <mat-label>{{ 'Extension.DialerTypesPlaceholder' | translate }}</mat-label>
                                                <mat-select formControlName="dialerType">
                                                    @for (type of dialerTypes; track type) {
                                                    <mat-option [value]="type">
                                                        {{ 'EnumDialerType.' + type | translate }}
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div>
                                            <div class="chip-list-formfield">
                                                <div class="chip-list-label">
                                                    <mat-label>{{ 'Extension.ExtensionsPlaceholder' | translate }}</mat-label>
                                                    <button matSuffix type="button" color="primary" mat-icon-button (click)="addExtensions()">
                                                        <mat-icon>add</mat-icon>
                                                    </button>
                                                </div>
                                                <mat-chip-listbox class="mat-mdc-chip-set-stacked" cdkDropList (cdkDropListDropped)="drop($event)" formControlName="extensions">
                                                    @for (extensionSelected of extensionForm.get('extensions').value; track extensionSelected) {
                                                    <mat-chip-option cdkDrag (removed)="removeExtension(extensionSelected)">
                                                        {{ getExtensionDisplay(extensionSelected) }}
                                                        <button matChipRemove>
                                                            <mat-icon>cancel</mat-icon>
                                                        </button>
                                                    </mat-chip-option>
                                                    } @if (extensionForm.get('extensions').value < 1) {
                                                    <input placeholder="" class="invisible-input" style="background: transparent; width: 0px" />
                                                    }
                                                </mat-chip-listbox>
                                            </div>
                                        </div>
                                        } @if (extensionForm.get('type').value === 'external') {
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.ExternalNumberPlaceholder' | translate }}</mat-label>
                                                <input matInput formControlName="externalNumber" autocomplete="off" [readonly]="!isCreation" />
                                            </mat-form-field>
                                        </div>
                                        } @if (extensionForm.get('type').value === 'user' || extensionForm.get('type').value === 'device') {
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.AccountPlaceholder' | translate }}</mat-label>
                                                <input matInput formControlName="account" autocomplete="off" [readonly]="extensionForm.get('type').value === 'device'" />
                                            </mat-form-field>
                                        </div>
                                        } @if (isCreation && extensionForm.get('type').value === 'user') {
                                        <div>
                                            <mat-form-field>
                                                <mat-label>{{ 'Extension.PasswordPlaceholder' | translate }}</mat-label>
                                                <input matInput type="password" formControlName="password" autocomplete="new-password" />
                                            </mat-form-field>
                                        </div>
                                        }
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            <mat-card style="width: 100%" appearance="outlined">
                                <mat-card-header>
                                    <mat-card-title class="card-title">{{ 'Extension.AuthorizationsTitle' | translate }}</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="input-content">
                                        <div>
                                            <mat-checkbox formControlName="allowInbound"></mat-checkbox>
                                            <mat-label>{{ 'Extension.AllowInbound' | translate }}</mat-label>
                                        </div>
                                        <div>
                                            <mat-checkbox formControlName="allowOutbound"></mat-checkbox>
                                            <mat-label>{{ 'Extension.AllowOutbound' | translate }}</mat-label>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            <mat-card style="width: 100%" appearance="outlined">
                                <mat-card-header>
                                    <mat-card-title class="card-title">{{ 'Extension.AdvancedFeaturesTitle' | translate }}</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="input-content">
                                        <div class="slide-toggle-form">
                                            <mat-slide-toggle formControlName="feature_VM" (change)="featureSelectionChange()"></mat-slide-toggle>
                                            <mat-label>{{ 'Features.VM' | translate }}</mat-label>
                                        </div>
                                        <div class="slide-toggle-form">
                                            <mat-slide-toggle formControlName="feature_VM_MAIL" (change)="featureSelectionChange()"></mat-slide-toggle>
                                            <mat-label>{{ 'Features.VM_MAIL' | translate }}</mat-label>
                                        </div>
                                        <div class="slide-toggle-form">
                                            <mat-slide-toggle formControlName="feature_VM_SMS" (change)="featureSelectionChange()"></mat-slide-toggle>
                                            <mat-label>{{ 'Features.VM_SMS' | translate }}</mat-label>
                                        </div>
                                        <div class="slide-toggle-form">
                                            <mat-slide-toggle formControlName="feature_VM_TRANSCRIPT" (change)="featureSelectionChange()"></mat-slide-toggle>
                                            <mat-label>{{ 'Features.VM_TRANSCRIPT' | translate }}</mat-label>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            @if (!isCreation) {
                            <mat-card style="width: 100%" appearance="outlined">
                                <mat-card-header>
                                    <mat-card-title class="card-title">{{ 'Extension.ConnectedSIPContactsTitle' | translate }}</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                                        <ng-container matColumnDef="networkAddress">
                                            <th mat-header-cell *matHeaderCellDef>{{ 'Extension.NetworkAddressPlaceholder' | translate }}</th>
                                            <td mat-cell *matCellDef="let element">{{ element.networkAddress }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="sipAddress">
                                            <th mat-header-cell *matHeaderCellDef>{{ 'Extension.SipAddressPlaceholder' | translate }}</th>
                                            <td mat-cell *matCellDef="let element">{{ element.sipAddress }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="userAgent">
                                            <th mat-header-cell *matHeaderCellDef>{{ 'Extension.UserAgentPlaceholder' | translate }}</th>
                                            <td mat-cell *matCellDef="let element">{{ element.userAgent }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="contactAddress">
                                            <th mat-header-cell *matHeaderCellDef>{{ 'Extension.ContactaddressPlaceholder' | translate }}</th>
                                            <td mat-cell *matCellDef="let element">{{ element.contactAddress }}</td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                                    </table>
                                </mat-card-content>
                            </mat-card>
                            }
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="save-button">
                <button mat-stroked-button type="button" color="accent" routerLink="/extensions">
                    {{ 'Extension.CancelButton' | translate }}
                </button>
                @if (extension.type !== 'device') {
                <button mat-raised-button color="accent" [disabled]="!extensionForm.valid" type="submit">
                    {{ 'Extension.SubmitButton' | translate }}
                </button>
                }
            </div>
        </form>
        }
    </div>
</div>
}
